import {
    VIEW_BUILDINGS,
    VIEW_MANUFACTURERS,
    VIEW_CAPACITY_UOMS,
    VIEW_TAG_CONDITIONS,
    VIEW_DEPARTMENTS,
    VIEW_FLOORS,
    VIEW_ROOMS,
    VIEW_PHOTO_TYPES,
    VIEW_CONDITIONS,
    VIEW_ASSET_DESCRIPTIONS,
    VIEW_EXISTING_ASSETS,
    VIEW_CUSTOM_ATTRIBUTES,
} from "../constant/ActionType";

const createMasterReducer = (actionType) => {
    return function masterDataReducer(
        state = { data: [], total: 0, currentPage: 1, perPage: 10, lastPage: 1 },
        action
    ) {
        if (action.type === actionType) {
            const rawData = action?.data?.data;
            const items = Array.isArray(rawData) ? rawData : rawData?.data || [];
            return {
                ...state,
                data: items,
                total: rawData?.total || items.length,
                currentPage: rawData?.current_page || 1,
                perPage: rawData?.per_page || 10,
                lastPage: rawData?.last_page || 1,
            };
        }
        return state;
    };
};

export const Buildings_reducer = createMasterReducer(VIEW_BUILDINGS);
export const Manufacturers_reducer = createMasterReducer(VIEW_MANUFACTURERS);
export const CapacityUoms_reducer = createMasterReducer(VIEW_CAPACITY_UOMS);
export const TagConditions_reducer = createMasterReducer(VIEW_TAG_CONDITIONS);
export const Departments_reducer = createMasterReducer(VIEW_DEPARTMENTS);
export const Floors_reducer = createMasterReducer(VIEW_FLOORS);
export const Rooms_reducer = createMasterReducer(VIEW_ROOMS);
export const PhotoTypes_reducer = createMasterReducer(VIEW_PHOTO_TYPES);
export const Conditions_reducer = createMasterReducer(VIEW_CONDITIONS);
export const AssetDescriptions_reducer = createMasterReducer(VIEW_ASSET_DESCRIPTIONS);
export const ExistingAssets_reducer = createMasterReducer(VIEW_EXISTING_ASSETS);
export const CustomAttributes_reducer = createMasterReducer(VIEW_CUSTOM_ATTRIBUTES);
